import React from 'react';
import Card from '../../shared/card';
import "./card-panel.css";
import { t, getCurrentLanguage } from '../../../utils/translations';
import useLanguageStore from '../../../store/languageStore';

class CardPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentLanguage: getCurrentLanguage()
        };
    }

    componentDidMount() {
        // Subscribe to language changes
        this.unsubscribe = useLanguageStore.subscribe((state) => {
            this.setState({ currentLanguage: state.currentLanguage });
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
    }

    render() {
        const { currentLanguage } = this.state;
        
        return (
            <div className="card-panel">
                <div className="card-panel-title-group">
                    <h4 className="card-panel-product-name">{t('linha_protheus', currentLanguage)}</h4>
                    <h1 className="card-panel-title">{t('destaques_principais', currentLanguage)} 12.1.2610</h1>
                </div>
                <div className="card-panel-content">
                    <Card 
                        text={t('pontos_atencao_release', currentLanguage)} 
                        link="https://tdn.totvs.com/x/vcyhQQ"
                    />
                    <Card 
                        text={t('nova_home_novo_browse', currentLanguage)} 
                        link="https://tdn.totvs.com/x/cvXRP"
                    />
                    <Card 
                        text={t('reforma_tributaria', currentLanguage)} 
                        link="https://espacolegislacao.totvs.com/protheus-reforma-tributaria/"
                    />
                    <Card 
                        text={t('descontinuacao_ctree', currentLanguage)} 
                        link="https://tdn.totvs.com.br/display/tec/Application+Server+-+CTREE"
                    />
                    <Card 
                        text={t('uso_obrigatorio_privilegios', currentLanguage)} 
                        link="https://tdn.totvs.com/pages/releaseview.action?pageId=1067035146"
                    />
                    <Card 
                        text={t('acesso_rapido', currentLanguage)} 
                        link="https://tdn.totvs.com/x/-syhQQ"
                    />
                </div>
            </div>
        );
    }
};

export default CardPanel;